export default __webpack_public_path__ + "static/media/touchpad3_active_v1.5f5df382.svg";